import React from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import ZhuyinImage from 'components/ZhuyinImage';

export const ZhuyinImageModalComponent = ({ zhuyinImageResource }) => {
  return <ExtendedContentContainer extendedContentType={ExtendedContentType.ZhuyinImage}>
    <ZhuyinImage resource={zhuyinImageResource} />
  </ExtendedContentContainer>
};